module.exports = __webpack_public_path__ + "08_face.90ba78d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer1/08_face.png
// module id = 6MlM
// module chunks = 0